import { rollbarConfig } from 'configs/rollbar'
import Rollbar from 'rollbar'

export const rollbar = new Rollbar(rollbarConfig)
